import { useContext } from 'react';
import { AuthContext } from '../components/AuthContext';

export function useAuth() {
  const authContext = useContext(AuthContext);

  if (!authContext) {
    return {
      isAuthenticated: false,
      user: null,
      token: null,
      tokenExpiration: null,
      login: () => {},
      logout: () => {},
      isLoading: false,
      isUnauthenticated: true,
      userEmail: null,
      userName: null,
      userImage: null,
      userId: null,
    };
  }

  return {
    isAuthenticated: authContext.isAuthenticated,
    user: authContext.user,
    token: authContext.token,
    tokenExpiration: authContext.tokenExpiration,
    login: authContext.login,
    logout: authContext.logout,
    isLoading: authContext.isLoading || false,
    isUnauthenticated: !authContext.isAuthenticated,
    userEmail: authContext.user?.email || null,
    userName:
      authContext.user?.firstName && authContext.user?.lastName
        ? `${authContext.user.firstName} ${authContext.user.lastName}`
        : authContext.user?.firstName || null,
    userImage: authContext.user?.image || null,
    userId: authContext.user?._id || null,
  };
}
